import { useCallback, useState } from 'react';
import { ServiceClient } from '../../../../../../Services/ServiceClient';
import { TeamType } from '../../../../../../Enums/TeamType';
import { useDebouncedEffect } from '../../../../../../Helpers/CustomHooks';

export const useParentTeamSerach = (query, setIsLoading, setIsOpen, parentTeamCodePrefix) => {
  const [teams, setTeams] = useState([]);

  const findTeams = useCallback(() => {
    if (!query || query.trim().length === 0 || query === parentTeamCodePrefix) {
      setTeams([]);
      return;
    }
    setIsLoading(true);
    ServiceClient.findTeams(
      query,
      data => {
        if (data?.length > 0) {
          setIsLoading(false);
          setTeams(data);
          setIsOpen(true);
        } else {
          setIsLoading(false);
          setTeams([]);
        }
      },
      () => {
        setIsLoading(false);
        setTeams([]);
        setIsOpen(false);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  useDebouncedEffect(findTeams, 500);

  return teams;
};

export const canShowTeamTypeSelector = team => {
  return team.parentTeamCodePrefix && team.parentTeamCodePrefix?.trim() !== '';
};

export const getParentTeamTypeOptions = () => {
  return [
    { key: TeamType.Regular, value: TeamType.Regular, displayName: '' },
    { key: TeamType.Subsidiary, value: TeamType.Subsidiary, displayName: TeamType.Subsidiary },
    { key: TeamType.Division, value: TeamType.Division, displayName: TeamType.Division },
  ];
};
